import { types } from "../action-types";

const initialState = {
  loading: false,
  offers: [],
  error: {},
  Index : null
};

const conversationFavReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_MESSAGE_TO_FAVOURITE_REQUESTED:
      return {
        ...state,
        loading: true,
        Index : action.payload?.Index
      };
    
    case types.ADD_MESSAGE_TO_FAVOURITE_SUCCESS:
      return {
        ...state,
        loading: false,
        offers: action.payload,
        error: {},
        Index:null
      };

    case types.ADD_MESSAGE_TO_FAVOURITE_FAILURE:
      return {
        ...state,
        loading: false,
        offers: [],
        error: action.error,
        Index:null
      };

    case types.REMOVE_MESSAGE_TO_FAVOURITE_REQUESTED:
      return {
        ...state,
        loading: true,
        Index:action.payload?.Index,
      };

    case types.REMOVE_MESSAGE_TO_FAVOURITE_SUCCESS:
      return {
        ...state,
        loading: false,
        offers: action.payload,
        error: {},
        Index:null
      };
    case types.REMOVE_MESSAGE_TO_FAVOURITE_FAILURE:
      return {
        ...state,
        loading: false,
        offers: [],
        error: action.error,
        Index:null
      };
    default:
      return { ...state };
  }
};

export default conversationFavReducer;
